import { frontendURL } from '../../../helper/URLHelper';
import RelatorioIndex from './pages/RelatorioIndex.vue';
import {
  LAIS_REPORT_MANAGE_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/desempenho-equipe'),
    alias: [frontendURL('accounts/:accountId/team-performance')],
    name: 'desempenho_equipe_index',
    redirect: laisCanonicalRedirect('relatorio_index', {
      query: { workspace: 'team' },
    }),
    meta: { permissions: LAIS_REPORT_MANAGE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/relatorio/metas'),
    alias: [
      frontendURL('accounts/:accountId/metas'),
      frontendURL('accounts/:accountId/targets'),
      frontendURL('accounts/:accountId/team-targets'),
    ],
    name: 'metas_index',
    redirect: laisCanonicalRedirect('relatorio_index', {
      query: { workspace: 'targets' },
    }),
    meta: { permissions: LAIS_REPORT_MANAGE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/relatorio'),
    alias: [
      frontendURL('accounts/:accountId/relatorio-v2'),
      frontendURL('accounts/:accountId/report'),
      frontendURL('accounts/:accountId/relatorios'),
      frontendURL('accounts/:accountId/relatorios-v2'),
      frontendURL('accounts/:accountId/produtividade'),
      frontendURL('accounts/:accountId/minha-atividade'),
      frontendURL('accounts/:accountId/atividade'),
      frontendURL('accounts/:accountId/plantao'),
      frontendURL('accounts/:accountId/atendimento-online'),
      frontendURL('accounts/:accountId/fila'),
    ],
    name: 'relatorio_index',
    component: RelatorioIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
